import { useLocation } from '@tanstack/react-router'

export const useIsRouteActive = (route: string, segment: string) => {
  const { pathname } = useLocation()
  const routeRegex = new RegExp(`\/${route}\/([a-zA-Z0-9-]+)\/${segment}(\/|$)`)

  const isRouteActive = routeRegex.test(pathname)
  return isRouteActive
}
